/*
 * @Author: wangshengqiang
 * @Date: 2021-11-02 14:58:58
 * @LastEditTime: 2022-01-06 22:31:02
 * @LastEditors: wangshengqiang
 * @Description: 保费算保额时 用来显示保额
 */
import React, { useEffect, useState } from 'react';
import { Cell } from 'zarm';
import { useStore } from '@/store';
export default function SumAssured(props) {
  const {
    label,
    attrs,
    formKey
  } = props;
  const totalSumInsured = useStore('premium.totalSumInsured');
  useEffect(() => {// if (!totalSumInsured) return;
    // setFormValue({
    //   [`${formKey}`]: totalSumInsured,
    // });
  }, []); // const [value, setValue] = useState('');

  if (!totalSumInsured) return null;
  return /*#__PURE__*/React.createElement(Cell, {
    title: label,
    description: `${totalSumInsured}元`
  });
}